module.exports = __webpack_public_path__ + "static/media/454A9115.d0b6f49b.jpg";